import type { JSX } from 'react'

import { IconProps } from './IconProps'

export const CheckBoxInactiveIcon = (props: IconProps): JSX.Element => {
  const width = props.width || '24'
  const height = props.height || '24'

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
    >
      <rect
        x='3'
        y='3'
        width='18'
        height='18'
        rx='4'
        stroke='var(--text-base-em)'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
